
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";

interface SideNavProps {
  collapsed: boolean;
}

export function SideNav({ collapsed }: SideNavProps) {
  const location = useLocation();
  
  const navItems = [
    { name: "Home", path: "/" },
    { name: "Account", path: "/account" },
    { name: "Knowledge", path: "/knowledge" },
    { name: "Users", path: "/users" },
    { name: "Motor API", path: "/motor-api" },
    { name: "DataOne API", path: "/dataone-api" },
    { name: "Analysis", path: "/analysis" },
    { name: "OpenAI", path: "/openai" },
    { name: "Calibration", path: "/calibration" },
    { name: "Logic Engine", path: "/logic-engine" },
    { name: "Quick Compare", path: "/quick-compare" },
    { name: "Azure Extraction", path: "/azure-extraction" },
    { name: "DataOne VIN Test", path: "/vin-test" },
  ];

  return (
    <nav className="flex-1 px-2 py-4 overflow-y-auto">
      <ul className="space-y-1">
        {navItems.map((item) => (
          <li key={item.path}>
            <Link
              to={item.path}
              className={cn(
                "flex items-center px-4 py-2 text-sm font-medium rounded-md transition-colors",
                location.pathname === item.path
                  ? "bg-primary/10 text-primary"
                  : "text-gray-700 hover:bg-gray-100 hover:text-gray-900",
                collapsed && "justify-center"
              )}
            >
              {collapsed ? (
                <span className="mx-auto">{item.name.charAt(0)}</span>
              ) : (
                <span>{item.name}</span>
              )}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
